import { ArrowRight, Phone } from "lucide-react";
import { MaskLines, Reveal } from "./Reveal";
import { PixelField } from "./PixelField";
import { openInquiry } from "../lib/scroll";
import { LOGO_WHITE } from "../data/content";

export const FinalCTA = () => {
  return (
    <section id="contact" data-testid="final-cta-section" className="px-3 sm:px-5 lg:px-8 py-6">
      <div className="relative overflow-hidden rounded-[2rem] sm:rounded-[3rem] bg-gradient-to-br from-[#C43E00] via-[#E65100] to-[#F05A24] noise-overlay">
        <PixelField />
        <div className="absolute inset-0 bg-gradient-to-t from-[#8F2F00]/45 via-transparent to-transparent" />
        <div className="relative z-10 px-6 sm:px-12 py-24 sm:py-36 text-center">
          <Reveal>
            <img src={LOGO_WHITE} alt="Nagel Landscaping" data-testid="final-cta-logo" className="h-10 sm:h-12 w-auto mx-auto mb-12" />
          </Reveal>
          <MaskLines
            as="h2"
            lines={[<>Have a landscape <span className="font-serif italic font-normal">worth building?</span></>]}
            className="font-display font-medium tracking-[-0.03em] leading-[1.04] text-4xl sm:text-6xl lg:text-7xl text-white max-w-4xl mx-auto"
          />
          <Reveal delay={0.2}>
            <p className="mt-7 text-sm sm:text-lg text-white/85 leading-relaxed max-w-2xl mx-auto">
              Whether you're developing a commercial property, transforming an existing landscape or creating something new at home, start with a team that knows how to take it from idea to finished space.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
              <button
                data-testid="final-cta-inquiry-button"
                onClick={() => openInquiry()}
                className="group inline-flex items-center gap-3 rounded-full bg-cream text-charcoal px-8 py-4 text-sm font-bold tracking-wide hover:bg-white hover:scale-[1.03] transition-all duration-300 shadow-[0_10px_36px_rgba(0,0,0,0.25)]"
              >
                SEND INQUIRY
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1.5" />
              </button>
              <a
                data-testid="final-cta-call-button"
                href="tel:+12095451696"
                className="group inline-flex items-center gap-3 rounded-full border border-white/40 text-white px-8 py-4 text-sm font-bold tracking-wide hover:bg-white/10 transition-colors duration-300"
              >
                <Phone className="w-4 h-4 transition-transform duration-300 group-hover:rotate-12" />
                CALL NAGEL
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.4}>
            <div className="mt-14 space-y-1.5">
              <p className="font-mono text-[10px] sm:text-xs tracking-[0.24em] text-white/70">COMMERCIAL &amp; RESIDENTIAL LANDSCAPE CONTRACTOR</p>
              <p className="font-mono text-[10px] sm:text-xs tracking-[0.24em] text-white/70">SERVING NORTHERN &amp; CENTRAL CALIFORNIA SINCE 1972</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
